import { CartProduct, Product } from "@/types/product";

export const productToCartProduct = (product: Product): CartProduct => {
  return {
    id: product.id,
    title: product.title,
    price: product?.variants?.[0]?.price,
    variant_id: product?.variants?.[0]?.id,
    quantity: 1,
    image: product?.images?.[0]?.src,
  };
};
